///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.invitations = abcsetup.thoughtspot.invitations || {};
abcsetup.thoughtspot.invitations.common = abcsetup.thoughtspot.invitations.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.invitations.common = {
    init() {
        $(document).on('change', '#vendor_name', function(e) {
            abcsetup.blockUI(true);

            axios.get('/api/thoughtspot/invitations/populate_vendor_id', {
                params: {
                    orgId: $(this).val()
                }
            })
            .then(response => {
                const data = response.data;

                if (data && data.vendor_id) {
                    abcsetup.unblockUI();
                    $('#app_models_thoughtspot_registration__vendor_id').val(data.vendor_id);
                } else {
                    abcsetup.unblockUI();
                }
            })
            .catch(error => {
                abcsetup.unblockUI();
                console.error(error);
                abcsetup.alerts.show('Something went wrong.', `Something went wrong fetching the selected supplier SAP Vendor Number: ${error.response.data.message}`);
            });
        });
    },
}